import { PcDriver } from '@acorn-portal/shared/src/services/subscriptionAPI';
import { DriverTableData } from '@acorn-portal/shared/src/components/table/driver-table';

/**
 * Converts an array of drivers into a table data format.
 *
 * @param drivers - Array of drivers of type `PcDriver`.
 * @returns An array of driver table data containing name and main driver status.
 */
export const getDriverTableData = (items: PcDriver[]): DriverTableData => {
	return items.map((item) => ({
		name: `${item.firstName} ${item.lastName}`,
		mainDriver: item.mainDriver,
		isProposer: !!item.isProposer,
	}));
};
